import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";
import ContactForm from "@/components/site/ContactForm";

const details = [
  { icon: Mail, label: "Email", value: "info@meditegroup.com" },
  { icon: MapPin, label: "Ubicación", value: "Barcelona, 08019 · España" },
];

export default function Contact() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="contact-page" className="bg-[#0B1F3A]">
      <section className="pt-36 md:pt-48 pb-24 md:pb-36">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          <motion.div initial="hidden" animate="visible" variants={stagger} className="lg:col-span-5 text-white">
            <motion.div variants={fadeUp} className="text-xs uppercase tracking-[0.25em] text-white/50 mb-6">Contacto</motion.div>
            <motion.h1 variants={fadeUp} className="text-5xl md:text-6xl lg:text-7xl font-serif tracking-tight leading-[0.98]">Solicita tu diagnóstico inicial.</motion.h1>
            <motion.p variants={fadeUp} className="mt-8 text-lg text-white/60 leading-relaxed max-w-md">Cuéntanos dónde estás y a dónde quieres llegar. Te responderemos en un día laborable, sin compromiso.</motion.p>

            <motion.div variants={fadeUp} className="mt-14 space-y-6">
              {details.map((d, i) => {
                const Icon = d.icon;
                return (
                  <div key={i} data-testid={`contact-detail-${i}`} className="flex items-center gap-4">
                    <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center">
                      <Icon size={18} className="text-white" />
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-[0.18em] text-white/40">{d.label}</div>
                      <div className="text-white/90">{d.value}</div>
                    </div>
                  </div>
                );
              })}
            </motion.div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.8 }} className="lg:col-span-6 lg:col-start-7">
            <ContactForm />
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
}
